import { Api } from "../config/request";

export default {
  getRolesList(filters) {
    return Api.get(`/roles${filters}`);
  },
  getRolesActions(role) {
    return Api.get(`/roles/actions?role=${role}`);
  },
  updateRole(payload) {
    return Api.post("/roles/actions/update", payload);
  },
  addRoles(payload) {
    return Api.post("/roles/actions/add-roles", payload);
  },
  getAllActions() {
    return Api.get("/actions");
  },
  bulkUploadRoles(payload) {
    return Api.post("/auth-details", payload);
  },
};
